
import { CondOperator, RequestQueryBuilder } from '@dataui/crud-request';
import axios from 'axios';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { LiveAgent } from '@gid/vue-common/components/ticketing/interface/ticketing';
import { TicketStatusEnum } from '@gid/models';
import { CRUD_PAGE_SIZE, fetchAllCrudPages } from '../../utils/crudList';
import LiveAgentTicket from './LiveAgentTicket.vue';

const FetchLiveAgentTickets = async ({
  job: {
    job: { name: jobName },
  },
}) => {
  const queryForPage = (page: number) =>
    RequestQueryBuilder.create({
      filter: [
        {
          field: 'jobs.name',
          operator: CondOperator.EQUALS,
          value: jobName,
        },
        {
          field: 'status',
          operator: CondOperator.NOT_EQUALS,
          value: TicketStatusEnum.X,
        },
      ],
      // `messages` is no longer eager on the controller, and LiveAgentTicket
      // renders the thread, so join it explicitly. Sort on a root column: a sort
      // over the to-many relation limits joined rows rather than tickets, which
      // repeats one ticket across pages and drops another.
      sort: [{ field: 'createdAt', order: 'ASC' }],
      join: [{ field: 'messages' }],
      limit: CRUD_PAGE_SIZE,
      page,
    }).query();

  // `GET /ticket` caps rows at 100; the busiest job has 220 linked tickets.
  return fetchAllCrudPages<LiveAgent.Ticket>('/data-api/ticket', queryForPage);
};

@Component({
  components: {
    LiveAgentTicket,
  },
  computed: mapGetters(['environment']),
})
export default class TicketsList extends Vue {
  @Prop({ default: null }) jobName!: string;
  @Prop({ default: null }) refreshTickets!: boolean;

  tickets: LiveAgent.Ticket[] = [];
  showAddTicket: boolean = false;
  dirtyFetchedDepartments: LiveAgent.Department[] = [];
  environment!: string;

  async created() {
    this.refreshLiveAgentTickets();
    this.refreshDepartments();
  }
  get liveAgentTickets() {
    if (!this.tickets || this.tickets.length < 1) return [];
    return this.tickets;
  }
  async refreshDepartments() {
    try {
      const response = await axios.get(
        `/data-api/ticket/live-agent/departments`,
      );
      this.dirtyFetchedDepartments = response?.data || [];
    } catch (error) {
      console.error('Error fetching departments:', error);
      this.dirtyFetchedDepartments = [];
    }
  }
  async delayedRefreshLiveAgentTickets() {
    setTimeout(this.refreshLiveAgentTickets, 5000);
  }
  async refreshLiveAgentTickets() {
    const response = await FetchLiveAgentTickets({
      job: { job: { name: this.jobName } },
    });
    this.tickets = response;
  }
  onModalClose() {
    this.showAddTicket = false;
  }
  @Watch('refreshTickets')
  onRefreshTickets(v) {
    if (v) this.delayedRefreshLiveAgentTickets();
  }
  @Emit('message-created')
  message_created() {
    return true;
  }
}
